import { localGoalsStore } from './local';
import { supabaseGoalsStore } from './supabase';
import { isSupabaseConfigured, getSupabase } from '@/lib/supabase';
import type { GoalsStore as GoalsStoreInterface } from './index';

// Use Supabase if configured, otherwise fall back to localStorage
const useSupabase = isSupabaseConfigured() && !!getSupabase();
console.log('🔍 GoalsStore adapter selection:', {
  isSupabaseConfigured: isSupabaseConfigured(),
  hasSupabaseClient: !!getSupabase(),
  usingSupabase: useSupabase,
});

// Create the store with explicit typing to avoid union type issues
let goalsStore: GoalsStoreInterface;
if (useSupabase) {
  goalsStore = supabaseGoalsStore as GoalsStoreInterface;
} else {
  goalsStore = localGoalsStore as GoalsStoreInterface;
}

export { goalsStore };
export type GoalsStore = GoalsStoreInterface;
